import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

const MissionControlMissionsProgressDropdown = () => (
  <DropdownMenuEllipsis tooltip="More actions" buttonVariant="ghost">
    <DropdownMenuItem href="/launchpad">Go to Launchpad</DropdownMenuItem>
  </DropdownMenuEllipsis>
);

export default MissionControlMissionsProgressDropdown;
